import { Specialty } from "@/graphql/graphql";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { selectHomepage, setOpenModal, setSpecialty } from "@/redux/state/homepage";
import { selectLanguage } from "@/redux/state/language";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
    Button, Card,
    CardBody,
    CardFooter, Col
} from "reactstrap";

const pickService_t_prefix = "pages.homePage.pickService";

interface SpecialtyCardProps {
    specialty: Specialty
}
const SpecialtyCard: React.FC<SpecialtyCardProps> = ({ specialty }) => {
    const { t } = useTranslation();
    const { currentLanguage } = useAppSelector(selectLanguage);
    const { choices } = useAppSelector(selectHomepage);
    const isChosen = () => {
        if (!choices.specialty) return false
        return choices.specialty[currentLanguage]?.title === specialty[currentLanguage]?.title
    }
    const dispatch = useAppDispatch();
    const select = t(`${pickService_t_prefix}.select`);
    const [isTapped, setIsTapped] = useState(false);
    const handleClick = (e: any) => {
        e.preventDefault();
        dispatch(setSpecialty(specialty));
        dispatch(setOpenModal({ modal: "specialty", isOpen: false }));
    };
    return (
        <Col>
            <Card
                style={{
                    marginTop: 0,
                    textAlign: "center",
                    // borderRadius: 0,
                    color: "white",
                    backgroundColor: "#444444",
                }}
                onTouchStart={() => setIsTapped(true)}
                onTouchEnd={() => setIsTapped(false)}
            >
                <CardBody>
                    <h6
                        style={{ marginTop: 0, textTransform: "capitalize" }}
                        className="category-social"
                    >
                        <span>{specialty[currentLanguage]?.title}</span>
                    </h6>
                    <CardFooter style={{ marginTop: 0 }}>
                        <Button
                            className={`btn-round select-button ${isChosen() ? "isChosen" : isTapped ? "isTapped" : ""
                                }`}
                            href="#pablo"
                            onClick={handleClick}
                            onMouseEnter={() => setIsTapped(true)}
                            onMouseLeave={() => setIsTapped(false)}
                        >
                            {select}
                        </Button>
                    </CardFooter>
                </CardBody>
            </Card>
        </Col>
    );
};

export default SpecialtyCard